import { render, staticRenderFns } from "./AHFavoritesEmpty.vue?vue&type=template&id=0e9debf3&"
import script from "./AHFavoritesEmpty.vue?vue&type=script&lang=ts&"
export * from "./AHFavoritesEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports